import { RedirectionStateObject } from './types';
import { settingsRedirections } from './pages/settings';
import { alertsRedirections } from './pages/alerts';
import { exploreRedirections } from './pages/explore';
import { spmRedirections } from './pages/spm';
import { kube360Redirections } from './pages/kube360';
import { integrationRedirections } from './pages/integrationRedirections';
import { unifiedDashboardsRedirections } from './pages/unified-dashboards';
import { dataHubRedirections } from './pages/data-hub';
import { OssRedirections } from './pages/oss';
import { ShortUrlRedirections } from './pages/short-url';
import { siemRedirections } from './pages/siem';
import { optimizersRedirections } from './pages/optimizers';

export const stateRedirections: RedirectionStateObject = {
  ...settingsRedirections,
  ...exploreRedirections,
  ...spmRedirections,
  ...alertsRedirections,
  ...kube360Redirections,
  ...integrationRedirections,
  ...unifiedDashboardsRedirections,
  ...dataHubRedirections,
  ...OssRedirections,
  ...ShortUrlRedirections,
  ...siemRedirections,
  ...optimizersRedirections,
};
